import {
  PricingContext,
  TirePartPricing,
} from "../../../queries/useSearchTiresByVehicle";

export const selectComparePricing = (
  pricing: TirePartPricing["price"]
): Partial<PricingContext> & { quantity: number } => {
  const price = Object.values(pricing).find(Boolean);
  const context = price?.contextList.find(Boolean);
  const quantity = Number(price?.quantity);
  return { ...context, quantity };
};
